import UserHome from "./UserHome";
// import PublicHome from "./PublicHome";

export default function Home() {
  return <UserHome />;
}
